import { mapState } from 'vuex';
export default {
    data() {
        return {
            items: [],
            itemsPerPage: {
                label: "Results",
                values: [10, 20, 50, 100],
            },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            search: '',
            loading: false
        }
    },
    computed: {
        ...mapState({
            token: state => state.token,
          }),
    },
    methods: {
        openOptions(elem) {
            const parentNode = elem.target.parentNode;
            const lastChild = parentNode.lastChild;

            if (parentNode.classList.contains("show")) {
                parentNode.classList.remove("show");
                lastChild.classList.remove("show");
            } else {
                // remove class from all dropdown rows
                const dropdowns = document.querySelectorAll('.table-dropdown-fix .dropdown');
                for(let i = 0; i < dropdowns.length; i++) {
                    dropdowns[i].classList.remove("show");
                    dropdowns[i].lastChild.classList.remove("show");
                }
                parentNode.classList.add("show");
                lastChild.classList.add("show");
            }
        },
        getRowCount(items) {
            return items.length;
        }
    }
};